import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@components/route/private-route';
import { PublicRoute } from '@components/route/public.route';

import { appConfig } from '@configs/app.config';
import { protectedRoutes, publicRoutes } from '@configs/routes.config';

import { AuthorizationRouteWrapper } from '../components/auth/authorization-wrapper';
import PageLoader from '../components/ui/loader/page-loader';

const AllRoutes = (_props: any) => {
    //   const userAuthority = useAppSelector((state) => state.auth.user.authority);
    const { authenticatedEntryPath } = appConfig;
    return (
        <Routes>
            <Route path="/" element={<ProtectedRoute />}>
                <Route
                    path="/"
                    element={<Navigate replace to={authenticatedEntryPath} />}
                />
                {protectedRoutes.map((route, index) => (
                    <Route
                        key={route.key + index}
                        path={route.path}
                        element={
                            <AuthorizationRouteWrapper
                                requiredPermission={route.authority[0]}
                            >
                                {route.component}
                            </AuthorizationRouteWrapper>
                        }
                    />
                ))}
                <Route path="*" element={<Navigate replace to="/" />} />
            </Route>
            <Route path="/" element={<PublicRoute />}>
                {publicRoutes.map((route: any) => (
                    <Route
                        key={route.path}
                        index
                        path={route.path}
                        element={route.component}
                    />
                ))}
            </Route>
        </Routes>
    );
};

export const RouteWrapper = (props: any) => {
    return (
        <Suspense fallback={<PageLoader />}>
            <AllRoutes {...props} />
        </Suspense>
    );
};
